/* eslint max-len: 0 */
import {
    RecommendationsRepository,
    AppIntegrationsRepository,
    ActivationCodesRepository,
} from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

/**
 * One Click Payment Product Comparison
 */


angular.module('controllers')
    .controller('OcpComparison', ($scope, $state, Util, $rootScope) => {

        const activationCodes = ActivationCodesRepository.getAll();
        const currentUserAppId = activationCodes[0].attributes.app;
        const recommendationAppFeatures = {};
        $scope.recommendationDetails = RecommendationsRepository.getAll() || [];
        $scope.recommendedApp = AppIntegrationsRepository.getById($state.params.resourceId) || {};
        $scope.currentUserApp = AppIntegrationsRepository.getById(currentUserAppId) || {};
        $scope.resourceId = $state.params.resourceId;
        $scope.language = CWCONFIG.language === 'de' ? 'de' : null;

        recommendationAppFeatures[$state.params.resourceId] =
            Util.deepFind($scope.recommendedApp, 'attributes.resource.comparisonFeatures');

        recommendationAppFeatures[currentUserAppId] =
            Util.deepFind($scope.currentUserApp, 'attributes.resource.comparisonFeatures');

        /**
         * Reorder recommended app features that match the users' current app to be first (top in comparison chart)
         */
        recommendationAppFeatures[currentUserAppId].forEach((feature) => {

            const featurePos = recommendationAppFeatures[$state.params.resourceId].indexOf(feature);

            if (featurePos > -1) {

                // remove feature from current position and add it to the beginning of the array
                recommendationAppFeatures[$state.params.resourceId].splice(featurePos, 1);
                recommendationAppFeatures[$state.params.resourceId].unshift(feature);

            }

        });

        $scope.closeModal = () => {

            Util.closeModal();

        };

        $scope.checkFeature = (newFeature =>
            recommendationAppFeatures[currentUserAppId].find(currentFeature => newFeature === currentFeature));
        $scope.recommendationAppFeatures = recommendationAppFeatures;


        $scope.upgradeNow = () => {

            let stateName = $state.current.name;
            let ltbName = 'one-click-payment';
            let subsource;
            let promotion;

            if (stateName.indexOf('.ltb') === -1) {

                stateName += '.ltb';

            }
            const recomendationAcronym = Util.deepFind($scope.recommendationDetails[0], 'attributes.acronym');
            if ($rootScope.hasValidPayment === false || recomendationAcronym !== $scope.resourceId || $scope.recommendationDetails.length === 0) {

                stateName += '.banner';
                ltbName = 'payment-cart';
                subsource = 'banner';
                promotion = true;

            }

            const recomendationId = $scope.recommendationDetails.length > 0 ? $scope.recommendationDetails[0].id : '';
            const productId = $scope.recommendedApp ? $scope.recommendedApp.id : '';
            const mixpanelDetails = {
                Modal: 'OCP Comparison Chart',
                'Button Label': 'Upgrade',
                Product: $scope.recommendedApp.attributes.name,
                'Product ID': productId,
                'Recommendation ID': recomendationId,
                Page: Util.getPageName(),
            };

            Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

            // open modal
            $state.go(stateName, {
                ltb: ltbName,
                resourceId: $scope.recommendedApp.id,
                subsource,
                promotion,
            }, {
                reload: false,
            });

        };

    });



// WEBPACK FOOTER //
// ./scripts/controllers/modals/ocp-comparison.js